import React from "react";

const PasswordChangeSkeleton: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Password Change Form Skeleton */}
      <div className="space-y-4">
        {/* Current Password */}
        <div>
          <div className="mb-2 block">
            <div className="w-32 h-4 bg-gray-200 rounded animate-pulse" />
          </div>
          <div className="h-10 bg-gray-200 rounded animate-pulse" />
        </div>
        {/* New Password */}
        <div>
          <div className="mb-2 block">
            <div className="w-32 h-4 bg-gray-200 rounded animate-pulse" />
          </div>
          <div className="h-10 bg-gray-200 rounded animate-pulse" />
        </div>
        {/* Confirm Password */}
        <div>
          <div className="mb-2 block">
            <div className="w-32 h-4 bg-gray-200 rounded animate-pulse" />
          </div>
          <div className="h-10 bg-gray-200 rounded animate-pulse" />
        </div>
      </div>
      {/* Save Button Skeleton */}
      <div className="w-full h-10 bg-gray-200 rounded animate-pulse mt-4" />
    </div>
  );
};

export default PasswordChangeSkeleton;
